import { OLD_SETTINGS_PATH } from 'cpmCarparks/navigation';

module.exports = {
  path: OLD_SETTINGS_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/CarparkSettings'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/routes/show/routes/settings/index.js